"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxIgnoreConversationArgs = void 0;
function serializeHxIgnoreConversationArgs(_arg) {
    var output = [];
    output.push(_arg.moveType);
    output.push(_arg.stopIgnoring);
    return output;
}
exports.serializeHxIgnoreConversationArgs = serializeHxIgnoreConversationArgs;
